/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                        Description
----------   -----------          --------------- ----------------     ------------------------
01 07 2018  1                     Professional service Initial version     

28-11-2019   1.1        Adhrish choudhary               chnanged the upload functionality 




*/
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { Router } from '@angular/router';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { Base64 } from '@ionic-native/base64/ngx';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { DomSanitizer } from '@angular/platform-browser';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
declare var window: any;
@Component({
  selector: 'app-aadharupdate',
  templateUrl: './aadharupdate.component.html',
  styleUrls: ['./aadharupdate.component.scss'],
})
export class AadharUpdateComponent implements OnInit {
  public aadharform: FormGroup;
  languageConext: any;
  headerTitle: any;
  currentpath;
  formsubmitted: boolean = false;
  file1: any = {};
  file2: any = {};
  FileSelected: any;
  Filearray: any;
  TrustFrontImgFile: any;
  TrustBackImgFile: any;
  FrontImgFile: any;
  BackImgFile: any;
  pdfIcon: any;
  FronImgName: any;
  BackImgName: any;
  aadhaarnumb;
  agreecheck: boolean = false;
  constructor(public formBuilder: FormBuilder,
    private router: Router,
    public navctrl: NavController,
    public platform: Platform,
    public cmndeclaration: CommonDeclarationService,
    public cmndef: CommonDefinitionService,
    private camera: Camera,
    public actionSheetController: ActionSheetController,
    private file: File,
    public api: RestapiService,
    private filePath: FilePath,
    private fileChooser: FileChooser,
    private base64: Base64,
    public actionVal: ActionlistenService,
    public _DomSanitizer: DomSanitizer,
    public menuCtrl: MenuController,
    public iosfilepicker: IOSFilePicker,
    public statusBar: StatusBar) {
    this.currentpath = this.router.url;

    if (this.cmndeclaration.LanguageJson) {
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].aadhar_form;

    }
    else {
      this.cmndeclaration.LanguageJson = JSON.parse(localStorage.languageJson);
      this.languageConext = this.cmndeclaration.LanguageJson['pages'][0].aadhar_form;

    }
    this.TrustFrontImgFile = 'assets/images/aadhaar.png';
    this.TrustBackImgFile = 'assets/images/aadhaar.png';
    this.pdfIcon = 'assets/images/pdfimg.PNG';
    this.headerTitle = this.languageConext.heading.text;
    this.aadharform = formBuilder.group({
      aadharnumber: ['', Validators.required]
    });
  }
  ngOnInit() {

  }

  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }
  async aadharupdate() {
    let res: any;
    if ((this.FronImgName == "" || this.FronImgName == undefined) || (this.BackImgName == "" || this.BackImgName == undefined)) {
      return false;
    }
    if (this.aadharform.valid && this.FrontImgFile && this.BackImgFile && this.agreecheck) {
      this.cmndef.loaderstart();
      var data = {};
      var fileDetails = [
        {
          "fileContent": this.FrontImgFile,
          "fileContentName": this.FronImgName
        },
        {
          "fileContent": this.BackImgFile,
          "fileContentName": this.BackImgName
        },
      ];
      data['userSessionID'] = localStorage.userSessionID;
      data['aadharNumber'] = this.aadharform.value.aadharnumber;
      data['userChatSessionID'] = localStorage.userChatSessionId;
      data['actionType'] = 'AADHAR_UPDATE';
      data['actionVal'] = fileDetails;
      this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      console.log(data);
      await this.api.postapi("akeiraVAAction", data).then(async data => {
        console.log(data);
        let res = data;
        this.cmndef.loaderend();
        this.cmndeclaration.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navctrl.navigateForward("/va/chat");
      });
    }
  }

  pickImage(sourceType) {
    let date = new Date();
    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        if (imageData.indexOf("file:/") != -1) {
          this.base64.encodeFile(imageData).then((base64File: string) => {
            if (this.FileSelected == "front") {
              this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
              this.FrontImgFile = base64File;
            } else {
              this.BackImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.BackImgFile = base64File;
              this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            }
          });
        } else {
          if (this.FileSelected == "front") {
            this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
            this.FrontImgFile = base64Image;
          } else {
            this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
              this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
            this.BackImgFile = base64Image;
          }
        }
      } else
        this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
    }, async (err) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      // Handle error
    });
  }
  async selectImage($event, flg: any) {
    this.FileSelected = flg
    this.cmndeclaration.Actionsheetenable = true;
    const actionSheet = await this.actionSheetController.create({
      header: "Select Image source",
      buttons: [{
        text: 'Load from Library',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          if (this.cmndeclaration.runPlatform == 'ios')
            this.IOSFileselect();
          else
            this.changeListener($event, flg);
        }
      },
      {
        text: 'Use Camera',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
          this.pickImage(this.camera.PictureSourceType.CAMERA);
        }
      },
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.cmndeclaration.Actionsheetenable = false;
        }
      }
      ]
    });
    await actionSheet.present();
  }


  async IOSFileselect() {
    let filePath: any;
    let fileName: any;
    let path: any;
    let validFormate: any;
    let stringLength: any;
    await this.iosfilepicker.pickFile().then(async uri => {
      filePath = "file://" + uri;
      fileName = filePath.split('/').pop();
      path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
      this.file.readAsDataURL(path, fileName).then(base64File => {
        sessionStorage.demo = base64File;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
          stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
          stringLength = stringLength.length;
          let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
          let sizeInMB = sizeInBytes / 1000000;
          if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
            if (this.FileSelected == "front") {
              this.FronImgName = fileName;
              this.FrontImgFile = base64File;
              if (validFormate.toLowerCase() == ".pdf")
                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
              else
                this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            } else {
              this.BackImgName = fileName;
              this.BackImgFile = base64File;
              if (validFormate.toLowerCase() == ".pdf")
                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
              else
                this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            }
          } else
            this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid");
        } else
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
      })
        .catch(() => {
          console.log('Error reading file');
        })
    })
      .catch(err => console.log('Error', err));
  }

  Fileselect() {
    let validFormate: any;
    let stringLength: any;
    if (this.platform.is('android')) {
      this.fileChooser.open()
        .then(
          uri => {
            this.filePath.resolveNativePath(uri)
              .then(url => {
                var fileName = url.substring(url.lastIndexOf("/") + 1);
                validFormate = url.substring(url.lastIndexOf("."), url.length);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                  this.base64.encodeFile(url).then((base64File: string) => {
                    if (validFormate.toLowerCase() == ".pdf") {
                      stringLength = base64File.indexOf("64,") + 3;
                      base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                      console.log(base64File);
                    } else
                      stringLength = base64File.length - 'data:image/png;base64,'.length;
                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                      if (this.FileSelected == "front") {
                        this.FronImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf")
                          this.TrustFrontImgFile = this.pdfIcon;

                        else
                          this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        this.FrontImgFile = base64File;
                      } else {
                        this.BackImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf")
                          this.TrustBackImgFile = this.pdfIcon;

                        else
                          this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        this.BackImgFile = base64File;
                      }
                    } else {
                      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
                    }
                  });
                } else {
                  this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                }

              })
              .catch(err => console.log(err));
          }
        )
        .catch(error => {
          console.log(error)
        });
    }
  }




  termscont() {
    if (this.agreecheck == false)
      this.agreecheck = true
    else
      this.agreecheck = false
  }


  validatefun(event: any, flg: any) {
    if (flg == 'aadhaarnumb') {
      this.aadhaarnumb = this.aadhaarnumb.replace(/[^0-9]/g, '');
    }
  }


  changeListener($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);
    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          if (this.FileSelected == "front") {
            this.FronImgName = name;
            this.FrontImgFile = imgname;
            if (validFormate.toLowerCase() == ".pdf")
              this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
            else
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
          } else {
            this.BackImgName = name;
            this.BackImgFile = imgname;
            if (validFormate.toLowerCase() == ".pdf")
              this.TrustBackImgFile = "assets/images/pdfimg.PNG"
            else
              this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
          }
        } else {
          this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " " + localStorage.imgsize + "MB", "invalid")
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndeclaration.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }

}